import ItemListContainer from "./ItemListContainer"

const Main = (lista) => {
    return (
        <main className="mt-3">
            <ItemListContainer lista={lista} />
        </main>
    )
}

export default Main
